import React from "react";

import { TButton } from "./types";
import "./newButton.scss";

export const Button = ({
  buttonTitle,
  disabled,
  onClick,
  type = "button",
}: TButton) => {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={() => onClick?.()}
      className="button"
    >
      {buttonTitle}
    </button>
  );
};
